/**
 * Created by Administrador on 9/22/2016.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .factory('languageService', languageService);

    languageService.$inject = ['$q', '$translate', 'LANGUAGES'];

    function languageService ($q, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();
